import BaseComponent from 'foundation/base-component';
import ChoicesWrapper from './choices-wrapper';
import baseItemTemplate from '../html/item.hbs';
import baseChoiseTemplate from '../html/choise.hbs';

export default class FormCustomSelectComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    static getRequiredRefs() {
        return ['native'];
    }

    init() {
        this.choicesWrapperInstance = new ChoicesWrapper(this.refs.native, {
            placeholderValue: this.options.placeholder,
            removeItemButton: ('removeItemButton' in this.options) ? this.options.removeItemButton : false,
            shouldSort: false,
            itemSelectText: '',
            classNames: {
                hiddenState: 'visually-hidden'
            },
            callbackOnCreateTemplates(strToEl) {
                const itemSelectText = this.config.itemSelectText;
                return {
                    item(classNames, data, removeItemButton) {
                        return strToEl(baseItemTemplate({
                            classNames,
                            data,
                            content: data.label,
                            removeItemButton
                        }));
                    },
                    choice(classNames, data) {
                        return strToEl(baseChoiseTemplate({
                            classNames,
                            data,
                            itemSelectText,
                            content: data.label
                        }));
                    },
                };
            },
        });
        this.choicesInstance = this.choicesWrapperInstance.getChoicesInstance();
        // hide dropdown on every select
        this.refs.native.addEventListener('choice', () => {
            this.choicesInstance.hideDropdown();
        }, false);
    }

    onDestroy() {
        this.choicesWrapperInstance.destroy();
    }
}
